import { createFileRoute } from "@tanstack/react-router";
import { HrPage } from "@/components/admin/hr/HrPage";

export const Route = createFileRoute("/pulse-ops-x7k2/hr")({
  component: HrPage,
});
